import React from 'react';

import { Footer, Header, PageLayout } from '../../components';
import PageContent from '../../features/OpReports';

const OpReportsPage = () => {
  return (
    <>
      <Header />
      <PageLayout>
        <PageContent />
      </PageLayout>
      <Footer />
    </>
  );
};

export default OpReportsPage;
